import { apiClient } from "@/shared/services/api";
import type { ApiResponse } from "@/features/auth/services/authApi";

export interface GreenhouseBed {
  id: string;
  bayId: string;
  bedNumber: string;
  description: string;
  sizeSquareMeters: number;
  plantCapacity: number;
  isActive: boolean;
  createdAt: string;
}

export interface CreateGreenhouseBedRequest {
  bayId: string;
  bedNumber: string;
  description: string;
  sizeSquareMeters: number;
  plantCapacity?: number;
}

export const greenhouseBedsApi = {
  getBedsByBayId: async (bayId: string): Promise<GreenhouseBed[]> => {
    const { data } = await apiClient.get<ApiResponse<GreenhouseBed[]>>(
      `/GreenhouseBeds/bay/${bayId}`
    );
    return data.data;
  },

  getBedById: async (id: string): Promise<GreenhouseBed> => {
    const { data } = await apiClient.get<ApiResponse<GreenhouseBed>>(
      `/GreenhouseBeds/${id}`
    );
    return data.data;
  },

  createBed: async (
    payload: CreateGreenhouseBedRequest
  ): Promise<GreenhouseBed> => {
    const { data } = await apiClient.post<ApiResponse<GreenhouseBed>>(
      "/GreenhouseBeds",
      payload
    );
    return data.data;
  },

  updateBed: async (
    id: string,
    payload: CreateGreenhouseBedRequest
  ): Promise<GreenhouseBed> => {
    const { data } = await apiClient.put<ApiResponse<GreenhouseBed>>(
      `/GreenhouseBeds/${id}`,
      payload
    );
    return data.data;
  },

  deleteBed: async (id: string): Promise<void> => {
    await apiClient.delete(`/GreenhouseBeds/${id}`);
  },
};